module.exports = __webpack_public_path__ + "static/img/banner_image.2c1d6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_image.png
// module id = 7Lrm
// module chunks = 0